import React from 'react';

function Square(props) {
    let color = props.alive? "#ff5638": "white";
    return (
      <div 
        className="square"
        style={{
          "background-color": color, 
          "box-sizing": "border-box"
        }}
      >
      </div>
    );
  }

export default Square;